module.exports = __webpack_public_path__ + "public/img/bg_02.d0089009.png";